module.exports = __webpack_public_path__ + "img/b2.7419868.png";